import React from 'react';
import { useController } from 'react-hook-form';
import { Grid, Typography } from '@mui/material';
const Input = ({
	control,
	defaultValue = '',
	disabled = false,
	label,
	name,
	placeholder = '',
	rules,
	type = 'text',
}) => {
	const { field, fieldState } = useController({
		control,
		name,
		defaultValue,
		disabled,
		rules,
	});
	return (
		<Grid
			display={'grid'}
			gap={'4px'}
			height={'max-content'}
		>
			<Typography
				variant="label"
				fontSize={'16px'}
				color={'#393733'}
			>
				{label}
			</Typography>
			<input
				type={type}
				{...field}
				placeholder={placeholder}
				style={{
					background: '#FFF5E0',
					color: '#393733',
					border: '1px solid #FFBF3F',
					padding: '0 6px',
					height: '32px',
					borderRadius: '4px',
					width: '100%',
				}}
			/>
			{fieldState?.error && (
				<Typography
					variant="span"
					color="#d82c0d"
					fontSize={'14px'}
				>
					{fieldState?.error?.message}
				</Typography>
			)}
		</Grid>
	);
};

export default Input;
